import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPostProject, payAddsOns } from '../../Apis/index';

export const ProjectPost = createAsyncThunk('projectpost', async ({ formData, token }, { rejectWithValue }) => {
    try {

        const response = await getPostProject(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const PayForAdd = createAsyncThunk('PayForAdddd', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await payAddsOns(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const projectpostSlice = createSlice({
    name: 'projectpost',
    initialState: {
        error: null,
        success: false,
        data: null,
        error1: null,
        success1: false,
    },
    reducers: {
        clearprojectpostStatus: state => {
            state.success = false;
            state.error = null;
            state.error1 = null;
            state.success1 = false;
        },

        clearprojectId: state => {
            state.data = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(ProjectPost.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(ProjectPost.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                // state.data = action.payload.data.data;
            })
            .addCase(ProjectPost.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(PayForAdd.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(PayForAdd.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(PayForAdd.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
    },

});
export const { clearprojectpostStatus, clearprojectId } = projectpostSlice.actions;
export default projectpostSlice.reducer;

